module.exports = __webpack_public_path__ + "media/4.bc5ad69c.mp4";